// eslint-disable-next-line import/prefer-default-export
export enum Weekday {
    Monday = 'mo',
    Tuesday = 'tu',
    Wednesday = 'we',
    Thursday = 'th',
    Friday = 'fr',
}
